import { ColumnsWidths } from '../../utils';

/* eslint-disable @typescript-eslint/naming-convention */
export const getColumnsWidths = (): ColumnsWidths[] => ([
  { Company: 180 }, { Investment: 100 }, { 'Estimated Fair value': 100 },
  { '% of rights, fully diluted': 120 }, { Country: 100 }, { Industry: 100 },
]);
/* eslint-enable @typescript-eslint/naming-convention */
